import { render, staticRenderFns } from "./cloud-picture.vue?vue&type=template&id=570380f8&scoped=true"
import script from "./cloud-picture.vue?vue&type=script&lang=js"
export * from "./cloud-picture.vue?vue&type=script&lang=js"
import style0 from "./cloud-picture.vue?vue&type=style&index=0&id=570380f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570380f8",
  null
  
)

export default component.exports